export default __webpack_public_path__ + "static/media/BLR-1.ced54c30.JPG";